import axios from 'axios';

import Login from './login';
import PowerBI from './powerbi';
import DashboardResource from './dashboardResource';
import Analytic from './analytic';

const success = (response) => response;
const failure = (error) => Promise.reject(error);

class ApiManager {
  constructor() {
    this.requiresAuth = false;
    // Core api for project
    this.coreObject = axios.create({
      baseURL: process.env.VUE_APP_BASE_API_APP_URL,
    });

    this.coreObject.interceptors.response.use(success, failure);

    this.login = new Login(this.coreObject);
    this.powerbi = new PowerBI(this.coreObject);
    this.dashboardResouce = new DashboardResource(this.coreObject);
    this.analytic = new Analytic(this.coreObject);
  }

  /**
   * Add any APIs that require authentication to the array within method.
   */
  setAuthHeader(authToken) {
    [
      this.login,
      this.powerbi,
      this.dashboardResouce,
      this.analytic,
      // add API needing authentication here
    ].forEach((api) => api.setAuthHeader(authToken));
  }
}

export default new ApiManager();
